import 'react-phone-number-input/style.css';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Row,
  Form as FormB,
} from 'react-bootstrap';
import {
  Field,
  Form,
  Formik,
} from 'formik';
import ym from 'react-yandex-metrika';
import styled from 'styled-components';
import * as yup from 'yup';
import queryString from 'query-string';
import { Link, useLocation, useHistory } from 'react-router-dom';
import PhoneInput, { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import loadable from '@loadable/component';
import _ from 'lodash';
import { useAlert } from 'react-alert';
import {
  useMutation, useQuery,
} from '@apollo/client';

import ArtField from '../components/forms/ArtField';
import { useTranslation } from '../components/hooks/useTranslation';
import ResendActivation from '../components/ResendActivation';
import config from '../config';
import {
  GQL_GET_ME,
  GQL_SIGNUP,
} from '../graphql/queries';
import {
  Auth,
  Authorization,
  Eye,
  H3,
  H4,
  Help,
  HelperBlock,
  HelperBlockRepeat,
  HelperName,
  Relative,
  StyledForm,
} from '../helpers/authStyle';
import {
  yEvent,
} from '../components/Tracker';
import { ContentContainer } from '../helpers/mainStyles';
import { LANG_RU } from '../locales';

const Icon = loadable(() => import('../components/Icon'));
const MetaTags = loadable(() => import('../components/MetaTags'));

const SignupScreen = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const alert = useAlert();
  const location = useLocation();

  const [show, setShow] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [mainPass, setMainPass] = useState(true);
  const [repeatPass, setRepeatPass] = useState(true);
  const [password, setPass] = useState('');
  const [passwordRepeat, setPassRepeat] = useState('');
  const [passwordCheck1, setCheck1] = useState(false);
  const [passwordCheck2, setCheck2] = useState(false);
  const [passwordCheck3, setCheck3] = useState(false);
  const [passwordCheck4, setCheck4] = useState(false);
  const [passwordCheck5, setCheck5] = useState(false);
  const [resend, setResend] = useState(false);
  const [me, setMe] = useState({});

  const { data: dataMe } = useQuery(GQL_GET_ME, { fetchPolicy: 'cache-and-network' });

  const [signup] = useMutation(GQL_SIGNUP);

  useEffect(() => {
    ym('hit', '/signup');
  }, []);

  useEffect(() => {
    if (_.get(dataMe, 'me._id')) {
      setMe(_.get(dataMe, 'me'));
    }
  }, [dataMe]);

  useEffect(() => {
    if (_.get(me, '_id')) {
      const search = queryString.parse(_.get(history.location, 'search', {}));
      const { returnUrl } = search;
      if (me.load_on_login === null) {
        history.push('/account');
      }
      history.push(returnUrl || `${me.load_on_login}`);
    }
  }, [me]);

  const validatePhone = (phone) => (phone
    ? isPossiblePhoneNumber(phone)
    && isValidPhoneNumber(phone)
    : true);

  const doneResend = () => {
    setResend(false);
    history.push('/');
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    setLoading(true);
    const search = queryString.parse(_.get(location, 'search', {}));
    const { returnUrl } = search;
    try {
      const response = await signup({ variables: values });
      const meData = _.get(response, 'data.signup', {});
      const error = _.get(response, 'errors.0', false);
      if (error) {
        if (_.get(error, 'extensions.code') === '401') {
          setResend(_.get(error, 'extensions.exception.email'));
          setLoading(false);
          return false;
        }
        alert.show(error.message, { type: 'danger' });
        setSubmitting(false);
        setErrors({
          email: error.message,
        });
        return false;
      }
      alert.show(t('send_instructions', { ns: 'alerts' }), { type: 'info' });
      history.push(returnUrl || `${meData.load_on_login === null ? meData.load_on_login = '/account' : meData.load_on_login}`);
      return true;
    } catch (e) {
      alert.show(t('admin_error', { ns: 'alerts' }), { type: 'danger' });
      // eslint-disable-next-line no-console
      console.log(e);
    }
    setLoading(false);
    return false;
  };

  const handlePasswordCheck = (e) => {
    const pass = e.target.name === 'password' ? e.target.value.trim() : password;
    const passRepeat = e.target.name === 'passwordRepeat' ? e.target.value.trim() : passwordRepeat;

    const check1 = password.length >= 8;
    const check2 = !!password.split('')
      .filter((c) => c.match(/[A-Za-zА-Яа-я]+$/)
        && c === c.toLowerCase()).length;
    const check3 = !!password.split('')
      .filter((c) => c.match(/[A-Za-zА-Яа-я]+$/)
        && c === c.toUpperCase()).length;
    const check4 = !!password.split('')
      .filter((c) => Number.isInteger(+c)
        || !c.match(/[A-Za-zА-Яа-я0-9]+$/)).length;
    const check5 = !!pass && pass === passRepeat;

    setPass(pass);
    setPassRepeat(passRepeat);
    setCheck1(check1);
    setCheck2(check2);
    setCheck3(check3);
    setCheck4(check4);
    setCheck5(check5);
  };

  const metrica = (target) => {
    yEvent(target);
  };

  const metaTags = {
    title: t('title', { ns: 'signup' }),
  };

  const nameRegex = /^[a-zA-Zа-яА-ЯйЙёЁ0-9 ]+$/;

  const validationSchema = yup.object().shape({
    name: yup.string()
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .matches(nameRegex, t('text_num_space', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .nullable(),
    email: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .max(70, t('maximum_length', { ns: 'validate', count: 70 }))
      .email(t('email_format', { ns: 'validate' })),
    phone: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .max(20, t('maximum_length', { ns: 'validate', count: 20 })),
    password: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .min(8, t('minimum_length', { ns: 'validate', count: 8 }))
      .max(70, t('maximum_length', { ns: 'validate', count: 70 })),
    passwordRepeat: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .oneOf([yup.ref('password', { ns: 'validate' })], t('eq_password', { ns: 'validate' }))
      .min(8, t('minimum_length', { ns: 'validate', count: 8 }))
      .max(70, t('maximum_length', { ns: 'validate', count: 70 })),
  });

  return (
    <Auth>
      <MetaTags {...metaTags} />
      {(isLoading) && (
      <div className="loader">
        <div className="bar" />
      </div>
      )}
      <ContentContainer>
        <Row>
          <Col lg={{ span: 8, offset: 2 }}>
            <H3>{t('name', { ns: 'signup' })}</H3>
            <Help>{t('info', { ns: 'signup' })}</Help>
            {resend ? (<ResendActivation onDone={doneResend} email={resend} />) : (
              <Formik
                initialValues={{
                  name: '',
                  username: '',
                  password: '',
                  phone: '',
                  passwordRepeat: '',
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  isSubmitting,
                  isValid,
                  dirty,
                  values,
                  setFieldValue,
                  errors,
                }) => (
                  <Form
                    onChange={handlePasswordCheck}
                  >
                    <StyledForm autoComplete="off">
                      <Field
                        name="name"
                        autoComplete="off"
                        label={(<H4>{t('complete_user', { ns: 'signup' })}</H4>)}
                        className="form-control-lg"
                        placeholder={t('complete_username_placeholder', { ns: 'signup' })}
                        component={ArtField}
                        column
                      />
                      <Field
                        name="email"
                        required
                        autoComplete="off"
                        label={(<H4>{t('email', { ns: 'signup' })}</H4>)}
                        className="form-control-lg"
                        placeholder={t('email_placeholder', { ns: 'signup' })}
                        component={ArtField}
                        column
                        onChange={handlePasswordCheck}
                      />
                      <FormB.Label column>
                        <H4>{t('phone', { ns: 'signup' })}</H4>
                      </FormB.Label>
                      <PhoneInput
                        international
                        name="phone"
                        required
                        autoComplete="off"
                        className={`form-control-lg ${(_.get(errors, 'phone') || !validatePhone(values.phone)) ? 'is-invalid' : ''}`}
                        value={values.phone}
                        placeholder={t('phone_placeholder', { ns: 'signup' })}
                        defaultCountry={LANG_RU}
                        onChange={(val) => setFieldValue('phone', val)}
                      />
                      {(_.get(errors, 'phone') || !validatePhone(values.phone)) && (
                      <FormB.Control.Feedback type="invalid">
                        {errors.phone || t('not_correct_phone', { ns: 'signup' })}
                      </FormB.Control.Feedback>
                      )}
                      <Relative>
                        <Field
                          name="password"
                          required
                          autoComplete="off"
                          label={(<H4>{t('password', { ns: 'signup' })}</H4>)}
                          className="form-control-lg"
                          placeholder={t('password_placeholder', { ns: 'signup' })}
                          type={mainPass ? 'password' : 'text'}
                          component={ArtField}
                          column
                          onFocus={() => setShow(!show)}
                          onBlur={() => setShow(!show)}
                          onChange={handlePasswordCheck}
                          append={(
                            <Eye
                              type="button"
                              onClick={() => setMainPass(!mainPass)}
                            >
                              <Icon
                                icon="eye"
                                colorFill="#FFF"
                                width={24}
                                height={12}
                                colorStroke={mainPass ? 'var(--art-main-gray)' : 'var(--art-active)'}
                                noHover
                              />
                            </Eye>
                        )}
                        />
                        <HelperBlock show={show ? 1 : 0}>
                          <HelperName>{t('recommendation', { ns: 'signup' })}</HelperName>
                          <p
                            className={`${(passwordCheck1 && passwordCheck2
                                  && passwordCheck3 && passwordCheck4)
                              ? 'text-success' : 'text-danger'}`}
                          >
                            {t('strong', { ns: 'signup' })}
                          </p>
                          <p className={`${passwordCheck1 ? 'text-success' : 'text-danger'}`}>
                            {t('length', { ns: 'signup' })}
                          </p>
                          <p className={`${passwordCheck2 ? 'text-success' : 'text-danger'}`}>
                            {t('lowercase_characters', { ns: 'signup' })}
                          </p>
                          <p className={`${passwordCheck3 ? 'text-success' : 'text-danger'}`}>
                            {t('uppercase_characters', { ns: 'signup' })}
                          </p>
                          <p className={`${passwordCheck4 ? 'text-success' : 'text-danger'}`}>
                            {t('numbers_special_characters', { ns: 'signup' })}
                          </p>
                        </HelperBlock>
                      </Relative>
                      <Relative>
                        <Field
                          name="passwordRepeat"
                          required
                          autoComplete="off"
                          label={(<H4>{t('confirm_password', { ns: 'signup' })}</H4>)}
                          className="form-control-lg"
                          onFocus={() => setShowRepeat(!showRepeat)}
                          onBlur={() => setShowRepeat(!showRepeat)}
                          placeholder={t('confirm_password_placeholder', { ns: 'signup' })}
                          type={repeatPass ? 'password' : 'text'}
                          component={ArtField}
                          append={(
                            <Eye
                              type="button"
                              onClick={() => setRepeatPass(!repeatPass)}
                            >
                              <Icon
                                icon="eye"
                                colorFill="#FFF"
                                width={24}
                                height={12}
                                colorStroke={repeatPass ? 'var(--art-main-gray)' : 'var(--art-active)'}
                                noHover
                              />
                            </Eye>
                        )}
                          column
                        />
                        <HelperBlockRepeat show={showRepeat ? 1 : 0}>
                          <p className={`${passwordCheck5 ? 'text-success' : 'text-danger'}`}>
                            {passwordCheck5
                              ? t('passwords_are_match', { ns: 'signup' })
                              : t('passwords_are_not_match', { ns: 'signup' })}
                          </p>
                        </HelperBlockRepeat>
                      </Relative>
                    </StyledForm>
                    <div className="d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-start mt-5">
                      <Button
                        variant="primary"
                        size="xl"
                        className={`col-12 col-md-auto mb-3 mb-md-0 px-5 ${isSubmitting || !(dirty && isValid) ? 'disabled' : ''}`}
                        type="submit"
                        onClick={() => metrica('registration')}
                        disabled={isSubmitting || !(dirty && isValid)}
                      >
                        {isSubmitting ? t('await', { ns: 'action' }) : t('registration', { ns: 'signup' })}
                      </Button>
                      <Authorization>
                        <div>{t('have_account', { ns: 'signup' })}</div>
                        <Link
                          className="ms-2"
                          to="/login"
                          onClick={() => metrica('login')}
                        >
                          {t('authorization', { ns: 'signup' })}
                        </Link>
                      </Authorization>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
            <ButtonLogin href={`${config.api}auth/google`}>
              <GoogleIcon src="/images/google-logo.svg" alt="google" />
              {t('google_auth', { ns: 'index' })}
            </ButtonLogin>
          </Col>
        </Row>
      </ContentContainer>
    </Auth>
  );
};

const GoogleIcon = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 20px;
`;

const ButtonLogin = styled.a`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--art-active);
  color: var(--art-dark);
  border-radius: 4px;
  margin-top: 40px;
  &:hover, &:focus {
    text-decoration: none;
    background-color: var(--art-active);
    color: white;
  }
`;

export default SignupScreen;
